__turbopack_context__.v({
  "className": "abril_fatface_6d21a778-module__8a-nEW__className",
  "variable": "abril_fatface_6d21a778-module__8a-nEW__variable",
});
